// Meta Pixel helper — injects the Meta Pixel script and exposes tracking helpers.
// Pixel ID is configured in PIXEL_ID below.

const PIXEL_ID = '2746653289031064'

declare global {
  interface Window {
    fbq?: any
    _fbq?: any
  }
}

let initialized = false

/**
 * Inject the Meta Pixel base code and initialize it.
 * Safe to call multiple times — only runs once.
 */
export function initPixel(): void {
  if (typeof window === 'undefined') return
  if (initialized || window.fbq) {
    initialized = true
    return
  }

  // Standard Meta Pixel base code (translated from the snippet, with a safer
  // script-injection strategy that works even if no <script> tag exists yet).
  ;(function (f: any, b: Document, e: string, v: string) {
    if (f.fbq) return
    const n: any = (f.fbq = function () {
      // eslint-disable-next-line prefer-rest-params
      n.callMethod
        ? n.callMethod.apply(n, arguments as any)
        : n.queue.push(arguments)
    })
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []
    const t = b.createElement(e) as HTMLScriptElement
    t.async = true
    t.src = v

    // Prefer inserting before an existing <script>, fall back to <head>, then <html>.
    const existingScript = b.getElementsByTagName(e)[0]
    if (existingScript && existingScript.parentNode) {
      existingScript.parentNode.insertBefore(t, existingScript)
    } else if (b.head) {
      b.head.appendChild(t)
    } else {
      b.documentElement.appendChild(t)
    }
  })(
    window,
    document,
    'script',
    'https://connect.facebook.net/en_US/fbevents.js',
  )

  window.fbq('init', PIXEL_ID)
  initialized = true
}

/** Fire a PageView event. */
export function trackPageView(): void {
  if (typeof window === 'undefined' || !window.fbq) return
  window.fbq('track', 'PageView')
}

/** Fire an AddToCart event with optional details. */
export function trackAddToCart(params?: {
  value?: number
  currency?: string
  content_name?: string
  content_ids?: string[]
  content_type?: string
}): void {
  if (typeof window === 'undefined' || !window.fbq) return
  window.fbq('track', 'AddToCart', params ?? {})
}
